































































































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import {
  CheckSquareIcon,
  ChevronDownIcon,
  CircleIcon,
  FileTextIcon,
  TrashIcon,
} from 'vue-feather-icons';
import { INotification, IPolicy, ITask, IDamage, ICustomer, NotificationEvent } from 'admiral-core';
import { NotificationApi } from '@/services/NotificationApi';
import AdmiralAvatar from '@/components/common/AdmiralAvatar.vue';
import AnnouncementModal from '@/modals/AnnouncementModal.vue';
import { Util } from '@/utils/Util';
import Avatar from '@/components/common/Avatar.vue';
import FlixcheckAvatar from '@/components/integrations/flixcheck/FlixcheckAvatar.vue';
@Component({
  name: 'notification-item',
  components: {
    AnnouncementModal,
    AdmiralAvatar,
    FileTextIcon,
    ChevronDownIcon,
    TrashIcon,
    CheckSquareIcon,
    CircleIcon,
    Avatar,
    FlixcheckAvatar,
  },
})
export default class NotificationItem extends mixins(BaseMixin, PermissionMixin) {
  @Prop({ required: true })
  notification!: INotification;

  isContentHovered = false;

  payload(notification: INotification) {
    switch (notification.event) {
      case NotificationEvent.Announcement:
        return (notification as INotification<NotificationEvent.Announcement>).payload;
    }
  }

  async toggleReadStatus(notification: INotification) {
    try {
      notification.readAt = notification.readAt ? null : new Date();
      await NotificationApi.update(notification.id, {
        readAt: notification.readAt,
      });
      this.$emit('reload');
    } catch (e) {
      console.log(e);
    }
  }

  isTaskNotification(notification: INotification) {
    return notification.task && notification.task.id;
  }

  isFlixcheckCheckAnsweredNotification(
    notification: INotification<NotificationEvent.FlixcheckCheckAnswered>,
  ) {
    return notification.event === NotificationEvent.FlixcheckCheckAnswered;
  }

  isDamageNotification(notification: INotification) {
    return notification.damage && notification.damage.id;
  }

  isMentionNotification(notification: INotification) {
    return (notification.event as NotificationEvent) === NotificationEvent.Mention;
  }

  async deleteNotification(notification: INotification) {
    try {
      await NotificationApi.delete(notification.id);
      this.$emit('delete', notification);
    } catch (e) {
      console.log(e);
    }
  }

  formatCreatedAt(date: Date) {
    return Util.formatDate(date);
  }
  async open(notification: INotification) {
    notification.readAt = null;
    await this.toggleReadStatus(notification);
    this.$emit('open', notification);
  }

  openTask(task: ITask) {
    const name = 'tasks2.edit';
    this.$router.push({ name, params: { id: task.id } });
  }

  openPolicy(policy: IPolicy) {
    this.$router.push({ name: 'policies.edit', params: { id: policy.id } });
  }

  openDamage(damage: IDamage) {
    this.$router.push({ name: 'damages.edit', params: { id: damage.id } });
  }

  openCustomer(customer: ICustomer) {
    this.$router.push({ name: 'customers.detail', params: { id: customer.id } });
  }
}
